var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "item-question" }, [
    _c(
      "button",
      {
        staticClass:
          "item-question-btn btn btn-primary item-question-btn item-question-btn--1",
        on: {
          click: function($event) {
            return _vm.openModal()
          }
        }
      },
      [_vm._v("Noch Fragen?")]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "item-question-modal-wrapper" }, [
      _c(
        "div",
        {
          staticClass: "modal fade item-question-modal",
          attrs: { tabindex: "-1", role: "dialog" }
        },
        [
          _c("div", { staticClass: "modal-dialog" }, [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _c("div", { staticClass: "modal-title h3" }, [
                  _vm._v("Noch Fragen?")
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "close",
                    attrs: {
                      type: "button",
                      "data-dismiss": "modal",
                      "aria-hidden": "true"
                    },
                    on: {
                      click: function($event) {
                        return _vm.closeModal()
                      }
                    }
                  },
                  [_vm._v("×")]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-body" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12 col-md-6 col-lg-3" }, [
                    _c("div", { staticClass: "input-unit" }, [
                      _c("input", {
                        staticClass: "form-control item-question-id",
                        attrs: { type: "text", disabled: "" },
                        domProps: { value: _vm.currentVariation.item.id }
                      }),
                      _vm._v(" "),
                      _c("label", [_vm._v("Artikel-ID")])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12 col-md-6 col-lg-9" }, [
                    _c("div", { staticClass: "input-unit" }, [
                      _c("input", {
                        staticClass: "form-control item-question-name",
                        attrs: { type: "text", disabled: "" },
                        domProps: { value: _vm.currentVariation.texts.name1 }
                      }),
                      _vm._v(" "),
                      _c("label", [_vm._v("Artikel-Name")])
                    ])
                  ]),
                  _vm._v(" "),
                  _vm._m(0),
                  _vm._v(" "),
                  _vm._m(1)
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-footer" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12 text-right" }, [
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-primary item-question-btn item-question-btn--2",
                        on: {
                          click: function($event) {
                            return _vm.send()
                          }
                        }
                      },
                      [_vm._v("Senden")]
                    )
                  ])
                ])
              ])
            ])
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("div", { staticClass: "input-unit" }, [
        _c("textarea", {
          staticClass: "form-control item-question-message",
          attrs: { placeholder: "Ihre Frage", required: "", rows: "5" }
        }),
        _vm._v(" "),
        _c("label", [_vm._v("Ihre Frage*")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("div", { staticClass: "input-unit" }, [
        _c("input", {
          staticClass: "form-control item-question-mail",
          attrs: {
            type: "email",
            value: "",
            placeholder: "Ihre E-Mail",
            required: ""
          }
        }),
        _vm._v(" "),
        _c("label", [_vm._v("Ihre E-Mail*")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }